import * as Yup from 'yup';
import { RetirementOptions } from '../RetirementPage.hooks';

export const INITIAL_VALUES: RetirementOptions = {
  totalAsset: 0,
  monthlyExpense: 3000000,
  annualReturnRate: 4,
  retirementAge: 60,
};

export const schema = Yup.object().shape({
  totalAsset: Yup.number()
    .required('보유 자산을 입력해주세요')
    .min(1, '1원 이상 입력해주세요'),
  monthlyExpense: Yup.number()
    .required('월 생활비를 입력해주세요')
    .min(1, '1원 이상 입력해주세요'),
  annualReturnRate: Yup.number()
    .required('예상 수익률을 입력해주세요')
    .min(0, '0% 이상 입력해주세요')
    .max(20, '20% 이하로 입력해주세요'),
  retirementAge: Yup.number()
    .required('은퇴 나이를 입력해주세요')
    .min(40, '40세 이상 입력해주세요')
    .max(80, '80세 이하로 입력해주세요'),
});
